import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Drawer, List, ListItemButton, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";

const NAV_LINKS = [
  { label: "All Cinemas", to: "/cinemas" },
  { label: "Popular Films", to: "/popular-films" },
  { label: "Popular Cities", to: "/popular-cities" },
  { label: "Search By Location", to: "/cinema-select" },
  { label: "About", to: "/about" },
];

export const Header = () => {
  const theme = useTheme();
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const toggleDrawer = (open: boolean) => () => setIsDrawerOpen(open);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Box sx={{ width: { xs: "90%", md: "100%" }, margin: "0 auto" }}>
          <Toolbar sx={{ justifyContent: "space-between", padding: 0 }}>
            {/* Logo/Home */}
            <IconButton
              component={Link}
              to="/"
              size="medium"
              edge="start"
              aria-label="home"
              sx={{
                color: theme.palette.primary.main,
                "&:hover": { backgroundColor: "transparent" },
                fontFamily: "'Roboto Mono', sans-serif",
                letterSpacing: "0.05rem",
              }}
            >
              CinemaGuide
            </IconButton>

            {/* Desktop nav (persistent internal links) */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1 }}>
              {NAV_LINKS.map((l) => (
                <Button
                  key={l.to}
                  component={Link}
                  to={l.to}
                  sx={{
                    textTransform: "none",
                    fontFamily: "'Roboto Mono', sans-serif",
                    color: theme.palette.primary.main,
                  }}
                >
                  {l.label}
                </Button>
              ))}
            </Box>

            {/* Mobile burger only */}
            <IconButton
              edge="end"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{ display: { xs: "flex", md: "none" } }}
            >
              <MenuIcon
                sx={{ color: theme.palette.primary.main }}
                fontSize="large"
              />
            </IconButton>
          </Toolbar>
        </Box>
      </AppBar>

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        ModalProps={{ keepMounted: true }} // keeps content mounted even when closed
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: 200, md: 300 },
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        <IconButton
          onClick={toggleDrawer(false)}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: theme.spacing(1),
            color: theme.palette.primary.main,
            "&:hover": { backgroundColor: "transparent" },
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>

        <List>
          {NAV_LINKS.map((l) => (
            <ListItemButton
              key={l.to}
              component={Link}
              to={l.to}
              onClick={toggleDrawer(false)}
            >
              <ListItemText
                primary={l.label}
                primaryTypographyProps={{
                  sx: {
                    fontFamily: "'Roboto Mono', sans-serif",
                    fontSize: { xs: "medium", md: "large" },
                  },
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </Box>
  );
};
